import  { type ReactElement } from 'react';

import { IconButton } from '@beeline/design-system-react/extracted-styles';

import clsx from 'clsx';

import styles from './styles.module.scss';
import type { ModifiedIconButtonProps } from './types';

export const ModifiedIconButton = ({
  className,
  ...rest
}: ModifiedIconButtonProps): ReactElement => {
  return (
    <div className={clsx(styles.wrap, className)}>
      <IconButton className={styles.btn} size='large' {...rest} />
    </div>
  );
};
